import { render } from "./ad.vue?vue&type=template&id=6bbd9d9c&scoped=true&ts=true"
import script from "./ad.vue?vue&type=script&lang=ts"
export * from "./ad.vue?vue&type=script&lang=ts"

import "./ad.vue?vue&type=style&index=0&id=6bbd9d9c&scoped=true&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbd9d9c"]])

export default __exports__